import { Button, Divider, Modal, Table } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import laboratoryPrices from "./laboratoryPrices";

const columns = [
  {
    title: "Ošetření",
    dataIndex: "name",
    key: "name",
    render: (text) =>
      text.startsWith("Fotokompozitní výplň") && !text.includes("krčková") ? (
        <Link to="/procedures">{text}</Link>
      ) : (
        text
      ),
  },
  {
    title: "Cena",
    dataIndex: "price",
    key: "price",
  },
];

const laboratoryColumns = [
  {
    title: "Kód",
    dataIndex: "code",
    key: "code",
    width: 100,
  },
  {
    title: "Název",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Cena pro pacienta",
    dataIndex: "price",
    key: "price",
    width: 140,
  },
  {
    title: "Cena pro nepojištěného pacienta",
    dataIndex: "uninsuredPrice",
    key: "uninsuredPrice",
    width: 170,
  },
];

const data = [
  {
    key: "1",
    name: "Fotokompozitní výplň malého rozsahu",
    price: "2500,-",
  },
  {
    key: "2",
    name: "Fotokompozitní výplň středního rozsahu",
    price: "3000,-",
  },
  {
    key: "3",
    name: "Fotokompozitní výplň velkého rozsahu",
    price: "3500,-",
  },
  {
    key: "4",
    name: "Fotokompozitní výplň krčková malá",
    price: "1500,-",
  },
  {
    key: "45",
    name: "Fotokompozitní výplň krčková velká",
    price: "2000,-",
  },
  {
    key: "5",
    name: "Fotokompozitní overlay přímá",
    price: "4000,-",
  },
  {
    key: "6",
    name: "Endodoncie 1kk včetně postendodontického ošetření",
    price: "6500,-",
  },
  {
    key: "7",
    name: "Endodoncie 2kk včetně postendodontického ošetření",
    price: "7200,-",
  },
  {
    key: "8",
    name:
      "Endodoncie 3kk (dolní moláry a horní sedmé moláry) včetně postendodontického ošetření",
    price: "9000,-",
  },
  {
    key: "9",
    name: "Endodoncie 4kk (horní 6 moláry) včetně postendodontického ošetření",
    price: "10000,-",
  },
  {
    key: "10",
    name: "Postendododontická dostavba bez FRC čepu",
    price: "2500,-",
  },
  {
    key: "11",
    name: "Postendododontická dostavba s FRC čepem",
    price: "2500,-",
  },
  {
    key: "12",
    name: "Konvenční fixace korunky",
    price: "900,-",
  },
  {
    key: "13",
    name: "Reendodoncie 1kk včetně postendodontického ošetření",
    price: "8000,-",
  },
  {
    key: "14",
    name: "Rendodoncie 2kk včetně postendodontického ošetření",
    price: "9000,-",
  },
  {
    key: "15",
    name:
      "Rendodoncie 3kk (dolní moláry a horní sedmé moláry) včetně postendodontického ošetření",
    price: "10200,-",
  },
  {
    key: "16",
    name: "Rendodoncie 4kk (horní 6 moláry) včetně postendodontického ošetření",
    price: "10500,-",
  },
  {
    key: "17",
    name: "Preprotetická chirurugie - prohloubení vestibula HČ",
    price: "3100,-",
  },
  {
    key: "18",
    name: "Preprotetická chirurugie - prohloubení vestibula DČ",
    price: "3300,-",
  },
  {
    key: "19",
    name: "Resekce kořenového hrotu pod OM",
    price: "4500,-",
  },
  {
    key: "20",
    name: "OTISK jedna čelist",
    price: "1800,-",
  },
  {
    key: "21",
    name: "OTISK myodynamický otisk",
    price: "3000,-",
  },
  {
    key: "22",
    name: "Subgingivální ošetření 1kvadrant",
    price: "3600,-",
  },
  {
    key: "23",
    name: "Konzultace",
    price: "900,-",
  },
  {
    key: "24",
    name: "Chirurgický výkon menšího rozsahu pomocí VFP",
    price: "900,-",
  },
];

class PriceList extends React.Component {
  state = { laboratoryVisible: false };

  closeLaboratory = () => {
    this.setState({ laboratoryVisible: false });
  };

  render() {
    return (
      <React.Fragment>
        <Divider>Ceník nejčastějších výkonů</Divider>
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          pagination={false}
          style={{ maxWidth: "550px", margin: "auto" }}
        />
        <div style={{ maxWidth: "550px", margin: "8px auto 0" }}>
          <Button
            type="link"
            onClick={() => this.setState({ laboratoryVisible: true })}
            aria-haspopup="dialog"
          >
            Protetický ceník
          </Button>
        </div>
        <Modal
          title="Protetický ceník"
          visible={this.state.laboratoryVisible}
          onCancel={this.closeLaboratory}
          width={1000}
          bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
          destroyOnClose
          footer={<Button onClick={this.closeLaboratory}>Zavřít</Button>}
        >
          <p>Ceník ze dne 13. 7. 2026</p>
          {laboratoryPrices.map(({ title, items }, index) => (
            <section key={title} style={{ marginBottom: "24px" }}>
              <h3>
                {index + 1}. {title}
              </h3>
              <Table
                columns={laboratoryColumns}
                dataSource={items}
                rowKey="code"
                size="small"
                pagination={false}
                scroll={{ x: 750 }}
              />
            </section>
          ))}
        </Modal>
      </React.Fragment>
    );
  }
}

export default PriceList;
